import {
	btn, CardContainer, CardMenu,
	cardmenu, cards,
	checkbox, combobox,
	comp, Component, containerfield,
	fieldset,
	Form,
	form, MapField, mapfield,
	numberfield, select,
	tbar, textarea,
	textfield,
	Window
} from "@intermesh/goui";

import {Field, Form as FormEntity} from "../Form";

import {jmapds} from "@intermesh/groupoffice-core";
import {t} from "../Translate";

export class DefaultFieldWindow extends Window {
	public readonly form;
	protected cardMenu: CardMenu;
	protected cards: CardContainer;
	protected generalTab!: Component;
	protected conditionsTab!: Component;
	protected conditionsField!: MapField;

	constructor(public readonly formEntity:FormEntity, type:string) {
		super();

		this.title = t("Field");
		this.stateId = "field-dialog";
		this.maximizable = true;

		this.height = 600;

		this.form = form<Field>({
			flex: 1,
			cls: "vbox",
			handler: async (form1) => {

				const field = form1.value as Field,
					fields = this.formEntity.fields ?? [],
					index = field.id ? fields.findIndex((value, index1, obj) => {
						return value.id == field.id;
					}) : -1;

				if(index > -1) {
					fields[index] = field;
				} else {
					fields.push(field);
				}

				this.mask();

				try {
					await jmapds("Form").update(formEntity.id, {
						fields: fields
					})
					this.close();
				} catch(e:any) {
					void Window.error(e.message);
				} finally {
					this.unmask();
				}
			}
		},
			this.cardMenu = cardmenu(),

			this.cards = cards({flex: 1},

				this.createGeneralTab(type),
				this.createConditionsTab()
			),

			tbar({},

				btn({
					type: "submit",
					text: t("Save")
				})

				),
		);

		this.items.add(this.form);
	}

	private createGeneralTab(type:string) {
		this.generalTab = comp({
				cls: "scroll fit",
				title: t("General")
			},

			fieldset({flex: 1, cls: "flow scroll"},
				numberfield({
					name: "id",
					hidden: true
				}),
				textfield({
					hidden: true,
					name: "type",
					value: type
				}),
				textfield({
					name: "label",
					label: t("Label"),
					maxLength: 49,
					required: true
				}),
				textfield({
					name: "hint",
					maxLength: 189,
					label: t("Hint")
				}),
				checkbox({
					type: "switch",
					name: "required",
					label: t("Required")
				})
			),
		)
		return this.generalTab;
	}

	private createConditionsTab() {
		this.conditionsTab = comp({
			title: t("Conditions"),
			cls: "fit scroll"
		},
			fieldset({

			},
				checkbox({
					type: "switch",
					name: "showIf",
					value: false,
					label: t("Show conditionally")
				}),
				checkbox({
					type: "switch",
					name: "requiredIf",
					value: false,
					label: t("Require conditionally")
				}),
				this.conditionsField = mapfield({
					name: "ifCondition",
					keyFieldName: "field",
					valueFieldName: "value",
					buildField: () => {
						const field = containerfield({
								cls: "group",
							},

							select({
								label: t("Field"),
								name: "field",
								options:
									this.formEntity.fields!.map((field) => {
										return {
											value: field.name,
											name: field.label
										}
									})
							}),

							textfield({
								name: "value",
								label: t("Value"),
								hint: t("Use 0 or 1 for checkbox values")
							}),

							btn({
								icon: "delete",
								title: "Delete",
								handler: (btn) => {
									field.remove();
								}
							})
						);

						return field;
					},
				}),
				tbar({},
					'->',
					btn({
						icon: "add",
						cls: "outlined",
						text: t("Add condition"),
						handler: () => {
							this.conditionsField.add("")
						}
					})
				)
			)
		);
		return this.conditionsTab;
	}
}